module.exports = __webpack_public_path__ + "media/images/lig/design-tiles/lig-tile-25-8d2b667cdceaa440a9dd5d16d9296464.jpg";